import gql from 'graphql-tag'
import { companyFragment } from '@/graphql/company/companyFragments'

export const COMPANIES = gql`
    query companies(
        $ids: [ID]
        $page: Int
        $first: Int
        $trashed: Trashed
    ) {
        companies(
            ids: $ids
            page: $page
            first: $first
            trashed: $trashed
        ){
            data{
                ...companyFragment
            }
        }
    }
    ${companyFragment}
`
export const COMPANIESSEARCH = gql`
    query companiesSearch(
        $searchText: String
        $page: Int
        $first: Int
        $trashed: Trashed
    ) {
        companiesSearch(
            searchText: $searchText
            page: $page
            first: $first
            trashed: $trashed
        ){
            data{
                ...companyFragment
            }
        }
    }
    ${companyFragment}
`